
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { SelectCulturalDefinition } from '../../interfaces/select-cultural-definition';
import { SelectOptions } from '../../interfaces/select-options';
import { ConnectServerService } from '../../../../services/connect-server.service';
import { CheckFormValidityService } from '../../../../services/check-form-validity.service';
import { PopupDialogService } from '../../../../services/popup-dialog.service';
import { Connect } from '../../../../classes/connect';
import { ApiResponse } from '../../../../interfaces/api-response';


@Component({
    selector: 'app-legal-condition',
    imports: [
    MatExpansionModule,
    ReactiveFormsModule
],
    templateUrl: './legal-condition.component.html',
    styleUrl: './legal-condition.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalConditionComponent {

  readonly panelOpenState = signal(false);

  @Input() idarticle: number = 0;
  @Input() listAcquisitionType: SelectOptions[] | null = null;
  @Input() listGenericIndication: SelectOptions[] | null = null;

  saved: boolean = false;
  submitted = false;

  legalForm: FormGroup;

  constructor(private fb: FormBuilder, private connectServerService: ConnectServerService,
    private popupDialogService: PopupDialogService, private checkFormValidityService: CheckFormValidityService) {
    this.legalForm = this.fb.group({
      acquisitionType: [null],
      name: [null, Validators.maxLength(50)],
      acquisitionDate: [null, Validators.maxLength(25)],
      acquisitionLocation: [null, Validators.maxLength(50)],
      generic_indication: [null, Validators.required],
      specific_indication: this.fb.array([this.createSpecificIndication()])
    });
  }

  ngOnInit(): void {
    this.getLegalInfo();
  }

  addSpecificIndication() {
    this.getSpecificIndicationControls().push(this.createSpecificIndication());
  }
  addSpecificIndicationValues(content: {id: number, indication: string}) {
    this.getSpecificIndicationControls().push(this.createSpecificIndicationValues(content));
  }

  removeSpecificIndication(index: number) {
    this.getSpecificIndicationControls().removeAt(index);
  }

  private createSpecificIndication(): FormGroup {
    return this.fb.group({
      id: [0],
      indication: [null, [Validators.required, Validators.maxLength(250)]]
    });
  }

  private createSpecificIndicationValues(content: {id: number, indication: string}): FormGroup {
    return this.fb.group({
      id: [content.id],
      indication: [content.indication, [Validators.required, Validators.maxLength(250)]]
    });
  }

  getSpecificIndicationControls(): FormArray {
    return this.legalForm.get('specific_indication') as FormArray;
  }

  private getLegalInfo() {
    this.connectServerService.getRequest('legalInfo', { idarticle: this.idarticle })
      .subscribe(
        (val: ApiResponse<{ infoLegal: any , giuridicalCondition: any}>) => {
          this.legalForm.patchValue(val.data.infoLegal);
          this.legalForm.get('generic_indication')?.setValue(val.data.giuridicalCondition.generic_indication);
          this.createNestedFields(val.data.giuridicalCondition.specific_indication);
          this.saved = this.checkFormValidityService.areAllRequiredFieldsFilled(this.legalForm);
          if (this.saved) {
            this.panelOpenState.set(false);
          }
          else {
            this.panelOpenState.set(true);
          }
        }
      )
  }

  private createNestedFields(giuridicalCondition: {id: number, indication: string}[]) {
    this.getSpecificIndicationControls().clear();
    giuridicalCondition.forEach(element => {
      this.addSpecificIndicationValues(element);
    });
  }

  private setLegalInfo() {
    const formValues = this.legalForm.getRawValue();
    // console.log(formValues);
    this.connectServerService.postRequest('updateLegalInfo',
      { idarticle: this.idarticle, infoLegal: formValues })
      .subscribe(
        (val: ApiResponse<null>) => {
          this.popupDialogService.popupDialog(val);
          this.getLegalInfo();
        }
      )
  }

  save() {
    this.submitted = true;
    if (this.legalForm.valid) {
      this.setLegalInfo();
    }
  }

}
